import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

/**
 * The `hub_sync` block OrdersController@create attaches to a successful
 * order-save response (see App\Services\HubDerive::afterOrder on the API).
 * The order itself is always already saved by the time this exists; it only
 * reports whether the board's Hub page heard about it.
 *
 * @typedef {Object} HubSync
 * @property {"submitted"|"skipped"|"failed"} status
 * @property {string} [reason]
 * @property {string} [message]
 * @property {number} [boards]
 */

/**
 * Surface a failed Hub write-back to the buyer and the console/log.
 *
 * "skipped" (not Hub-linked, no Hub token, uploaded locally, ...) is an
 * everyday, expected outcome and stays silent -- only "failed" (the Hub
 * write-back actually broke) is worth interrupting the buyer for, since the
 * order saved fine but the board's Hub page may now be out of step with it.
 *
 * @param {HubSync|null|undefined} hubSync
 */
export const warnIfHubSyncFailed = (hubSync) => {
  if (!hubSync || hubSync.status !== "failed") return;

  // eslint-disable-next-line no-console
  console.warn("Hub sync failed for this order:", hubSync);

  MySwal.fire({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 6000,
    timerProgressBar: true,
    icon: "warning",
    title: "Order saved, but the Hub was not updated",
    text:
      hubSync.message ||
      "The board's Hub page may not reflect this order yet.",
  });
};
